import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ClausesUtil } from '@xengage/gw-policycommon-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import { ClauseService } from 'gw-capability-policycommon';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import presentationMetadata from '../config/PremierSR-wizard-config.json5';

const PATH_TO_MOCK_DATA = 'quote.PremierSR';
const MOCK_DATA_TO_REMOVE = ['bindData.contactPhone'];

export default ({
    productCode,
    history,
    location,
    viewModelService,
    setIsLoading,
}) => {
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const [submissionVM, setInitialSubmission] = useState(null);
    const [wizardSteps, setWizardSteps] = useState(null);
    const [wizardTitle, setWizardTitle] = useState(null);

    useEffect(() => {
        const loadSubmission = async () => {
            if (!location.state) {
                history.push('/');
                return;
            }
            const { postalCode, quoteID } = location.state.quoteentry;
            const requestData = {
                quoteID: quoteID,
                postalCode: postalCode,
            };
            LoadSaveService.retrieveSubmission(requestData, authHeader)
                .then(response => {
                    return MockUpUtil.cleanUpMockedProperties(
                        response,
                        PATH_TO_MOCK_DATA,
                        ...MOCK_DATA_TO_REMOVE
                    );
                })
                .then(response => {
                    ClausesUtil.getDependentClausesFromServer(
                        ClauseService,
                        _.get(response, 'quoteID'),
                        authHeader
                    );
                    const initialSubmission = viewModelService.create(
                        response,
                        'pc',
                        'edge.capabilities.quote.submission.dto.QuoteDataDTO'
                    );
                    setInitialSubmission(initialSubmission);
                    setIsLoading(false);
                });

            setWizardTitle(
                _.get(presentationMetadata, [
                    `${productCode}.default.wizard`,
                    'title',
                ])
            );
            setWizardSteps(
                _.get(presentationMetadata, [
                    `${productCode}.default.wizard`,
                    'steps',
                ])
            );
        };
        loadSubmission();
    }, []);

    return {
        submissionVM,
        wizardSteps,
        wizardTitle,
        presentationMetadata,
    };
};
